import { ListEmptyProps, TableV2 } from '@anytag/shared-atoms';
import { useSelectItem } from '@anytag/shared-hooks';
import { ConfirmDeleteModal } from '@anytag/shared-molecules';
import { TableData } from '@anytag/shared-types';
import { useAccountsListTable, AccountsListTableProps } from './hooks';
import { AccountType, DeleteAccountType } from './types';

export interface AccountsListProps
  extends TableData<AccountType>,
    Pick<AccountsListTableProps, 'domain' | 'editRoute' | 'firstColumnTitle'> {
  deleting?: boolean;
  empty?: ListEmptyProps;
  onDeleteAccount?: (account: DeleteAccountType) => Promise<void>;
}

export const AccountsList = ({
  empty,
  domain,
  loading,
  deleting,
  data = [],
  editRoute,
  onDeleteAccount,
  firstColumnTitle
}: AccountsListProps) => {
  const { selectedItem, setSelectedItem, resetSelectedItem } = useSelectItem();
  const { columns } = useAccountsListTable({
    domain,
    editRoute,
    firstColumnTitle,
    onDeleting: onDeleteAccount ? setSelectedItem : undefined
  });

  const handleDeleteAccount = async () => {
    if (selectedItem) {
      await onDeleteAccount?.(selectedItem);
    }
    resetSelectedItem();
  };

  return (
    <>
      <TableV2 loading={loading} data={data} columns={columns} noTopBorderRadius empty={empty} hasBorder />

      <ConfirmDeleteModal
        deleting={deleting}
        onClose={resetSelectedItem}
        deletingItem={selectedItem}
        onDelete={handleDeleteAccount}
      />
    </>
  );
};

export * from './types';
